import React, { useState, useCallback } from 'react';

import { FullFrame } from '@vlabs/monokit/shared/ui/full-frame';
import { isEqual } from 'lodash';
import PropTypes from 'prop-types';

import st from './FullFrameWithInteractiveBBox.module.sass';

export function FullFrameWithInteractiveBBox({
  imageUrl = undefined,
  testId = undefined,
  detections = [],
  onClick = undefined,
}) {
  const [scaledDetections, setScaledDetections] = useState(null);

  const calculateScaledDetection = useCallback((fullFrameSize) => {
    const scaleX = (fullFrameSize.containerSize.width / fullFrameSize.imageSize.width);
    const scaleY = (fullFrameSize.containerSize.height / fullFrameSize.imageSize.height);

    const newScaledDetections = detections.map((d) => ({
      x: d.x * scaleX,
      y: d.y * scaleY,
      width: d.width * scaleX,
      height: d.height * scaleY,
      type: d.type,
    }));

    if (isEqual(newScaledDetections, scaledDetections)) return;

    setScaledDetections(newScaledDetections);
  }, [detections, scaledDetections]);

  return (
    <FullFrame
      className={st.FullFrame}
      data-testid={testId}
      src={imageUrl}
    >
      {(size) => {
        // FIXME Подумать, как забирать размер для расчётов компонента не в момент рендера (не очень хороший паттерн)
        calculateScaledDetection(size);

        return scaledDetections && (
          <React.Fragment>
            {scaledDetections.map(({
              x, y, width, height, type,
            }) => (
              <div
                className={st.DetectionWrapper}
                key={type}
                style={{
                  clipPath: `inset(
                ${y}px
                calc(100% - (${x + width}px))
                calc(100% - (${y + height}px))
                ${x}px)`,
                }}
              >
                <img
                  alt="Full frame clipped"
                  data-testid={`eventDetails.detectionImage.${type}`}
                  src={imageUrl}
                />
                <button
                  aria-label="Select sample button"
                  className={st.BoundingBox}
                  data-testid={`eventDetails.selectDetectionButton.${type}`}
                  onClick={() => onClick(type)}
                  style={{
                    top: y,
                    width,
                    height,
                    left: x,
                  }}
                  type="button"
                />
              </div>
            ))}
          </React.Fragment>
        );
      }}
    </FullFrame>
  );
}

FullFrameWithInteractiveBBox.propTypes = {
  imageUrl: PropTypes.string,
  testId: PropTypes.string,
  detections: PropTypes.array,
  onClick: PropTypes.func,
};
